import React from "react";

const PlusCircleIcon = (props: any) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>plus-circle-icon</title>
      <path
        d="M8 16c-4.418 0-8-3.582-8-8s3.582-8 8-8 8 3.582 8 8-3.582 8-8 8zM8 2C4.686 2 2 4.686 2 8s2.686 6 6 6 6-2.686 6-6-2.686-6-6-6zm4 7H9v3c0 .552-.448 1-1 1s-1-.448-1-1V9H4c-.552 0-1-.448-1-1s.448-1 1-1h3V4c0-.552.448-1 1-1s1 .448 1 1v3h3c.552 0 1 .448 1 1s-.448 1-1 1z"
        fill="#000"
        fillRule="evenodd"
      />
    </svg>
  );
};

export default PlusCircleIcon;
